import { Text } from '@mantine/core';
import { useGroup } from 'app/Private/GroupGate';
import { TenantCards } from 'app/Private/GroupOverview/TenantCards';
import { useGroupTenants } from 'app/Private/GroupView/consolidation';
import { PageTitle } from 'components';
import { i18nKeys, useTranslation } from 'locales';

export const GroupCompanies = () => {
  const { t } = useTranslation();
  const group = useGroup();
  const groupTenants = useGroupTenants();

  return (
    <>
      <PageTitle>{t(i18nKeys.GROUP.COMPANIES)}</PageTitle>
      <Text c="gray.6" mb="md">
        {t(i18nKeys.GROUP.COMPANIES_REACHED, {
          count: groupTenants.length,
          total: group.companiesCount,
        })}
      </Text>
      <TenantCards tenants={groupTenants} />
    </>
  );
};
